import type { Nullish } from "~/@types/generics"
import { LOCALES } from "~/lib/i18n/constants"
import type { I18nLocale } from "~/lib/i18n/types"

export function isLocale(locale: Nullish<string>): locale is I18nLocale {
  return !!locale && LOCALES.includes(locale)
}
